const allowSequentialNumberingLogisticRecordReducer = (allowSequentialNumberingLogisticRecord = false, action) => {
    switch (action.type) {
        case "ADD_ALLOW_SEQUENTIAL_NUMBERING_LOGISTIC_RECORD":
            return action.payload;
        default:
            return allowSequentialNumberingLogisticRecord;
    }
};

export default allowSequentialNumberingLogisticRecordReducer;